<template>
  <v-container fluid>
    <v-skeleton-loader :loading="productLoading" :types="skeleton" type="article" class="mb-6">
      <v-card class="elevation-1 mb-6 rounded-lg">
        <v-card-title class="pa-7">
          Produkt
          <v-spacer></v-spacer>
          <ProductStatus v-if="product" :status="product.status" />
        </v-card-title>
        <v-card-text class="pa-7">
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">ID</div>
                  <div class="request-value mt-2">{{ product ? product.id : '-' }}</div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">ID TZB</div>
                  <div class="request-value mt-2">
                    {{ product && product.tzbProductId ? product.tzbProductId : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Název</div>
                  <div class="request-value mt-2">{{ product ? product.name : '-' }}</div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">Typ</div>
                  <div class="request-value mt-2">{{ product ? product.type.text : '-' }}</div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Fixace</div>
                  <div class="request-value mt-2">
                    <YesNo v-if="product" :value="product.fixed" />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Typ smlouvy</div>
                  <div class="request-value mt-2">
                    {{ product && product.contractType ? product.contractType.text : '-' }}
                  </div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">Délka smlouvy</div>
                  <div class="request-value mt-2">
                    {{ product && product.contractPeriod ? product.contractPeriod : '-' }}
                    {{
                      product && product.contractPeriodUnit ? product.contractPeriodUnit.text : '-'
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Administrace - zobrazení</div>
                  <div class="request-value mt-2">
                    <EnabledDisabled v-if="product" :value="product.adminEnabled" />
                  </div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">Zákazník - zobrazení</div>
                  <div class="request-value mt-2">
                    <EnabledDisabled v-if="product" :value="product.clientEnabled" />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-6 mr-3 ml-3"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Vytvořeno</div>
                  <div class="request-value mt-2">
                    <DateTime v-if="product" :single-line="false" :datetime="product.createdAt" />
                  </div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">Změněno</div>
                  <div class="request-value mt-2">
                    <DateTime v-if="product" :single-line="false" :datetime="product.updatedAt" />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Zdroj</div>
                  <div class="request-value mt-2">
                    <div class="request-value mt-2">{{ product ? product.source.text : '-' }}</div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pl-7 pr-7 pb-7">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            height="40px"
            min-width="130px"
            style="color: #e53935"
            outlined
            depressed
            @click="removeSupplierProduct()"
          >
            Smazat
          </v-btn>
          <v-btn
            type="submit"
            height="40px"
            min-width="130px"
            color="primary"
            :to="{
              name: 'suppliers.detail.product.edit',
              params: {
                productId: $route.params.productId,
                type: $route.params.type,
                supplierId: $route.params.supplierId,
              },
            }"
            depressed
          >
            Editovat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-skeleton-loader>
    <SupplierElectricityProductPrices v-if="$route.params.type.toUpperCase() === 'ELECTRICITY'" />
    <SupplierGasProductPrices v-if="$route.params.type.toUpperCase() === 'GAS'" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import SupplierElectricityProductPrices from '../../../components/product/SupplierElectricityProductPrices'
import SupplierGasProductPrices from '../../../components/product/SupplierGasProductPrices'
import EnabledDisabled from '../../../components/EnabledDisabled'
import DateTime from '../../../components/DateTime'
import YesNo from '../../../components/YesNo'
import ProductStatus from '../../../components/product/ProductStatus'

export default {
  name: 'SupplierProductDetail',
  components: {
    ProductStatus,
    YesNo,
    DateTime,
    EnabledDisabled,
    SupplierGasProductPrices,
    SupplierElectricityProductPrices,
  },
  mixins: [setFilters],
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      product: null,
      productLoading: null,
    }
  },
  created() {
    this.loadProduct()
  },
  methods: {
    ...mapActions({
      getSupplierProduct: 'supplier/getSupplierProduct',
      deleteSupplierProduct: 'supplier/deleteSupplierProduct',
    }),
    loadProduct() {
      this.productLoading = true
      this.getSupplierProduct({
        supplierId: this.$route.params.supplierId,
        productId: this.$route.params.productId,
        type: this.$route.params.type,
      })
        .then((response) => {
          this.product = response.data
        })
        .finally(() => {
          this.productLoading = false
        })
    },
    removeSupplierProduct() {
      this.$confirm('', {
        title: 'Smazat produkt?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.product.loading = true
          this.deleteSupplierProduct({
            supplierId: this.$route.params.supplierId,
            productId: this.$route.params.productId,
            type: this.$route.params.type,
          })
            .then(() => {
              this.$router.back()
            })
            .finally(() => {
              this.product.loading = false
            })
        }
      })
    },
  },
}
</script>
